import { connect } from "react-redux";

import TrialBanner from "../../components/trial_banner/trial_banner";

export default connect(
  store => ({
    currentOrganization: store.session.data && store.session.data.organization
  })
)(TrialBanner);
